/**
 * English translations for watchout analysis
 */
const watchout = {
  watchout: {
    title: "Areas to Watch Out For",
    noData: "No watchout data available for analysis",
    命宫: {
      紫微: "Avoid being too proud, too cold, or having overly high expectations that lead to loss of rapport",
      天府: "Being too conservative and lacking innovation",
      天相: "Pursuing harmony excessively while neglecting your own needs",
      武曲: "Weak emotional expression, tendency to suppress feelings, working hard without speaking up",
      天机: "Overthinking, indecisiveness, plans always falling behind action",
      文曲: "Being too emotional, overthinking, tendency for self-pity",
      文昌: "Excessive rationality, being too rigorous, focusing on form at the expense of action",
      贪狼: "Short-lived enthusiasm, scattered energy, pulled in many directions by emotions and desires",
      太阳: "Giving too much and becoming drained, unable to express vulnerability, keeping up appearances",
      太阴: "Suppressing emotions, considering others too much, avoiding conflict",
      巨门: "Being misunderstood as aggressive, hurting others with your direct expression",
      天同: "Avoiding conflict, tending to withdraw, overly dependent on others' evaluations",
      七杀: "Moving too fast for others to follow, experiencing mood swings, depleting energy after outbursts",
      破军: "Self-destructive path-switching, excessive rejection of the past, difficulty settling down",
      左辅: "Excessive self-sacrifice, lacking personal opinions",
      右弼: "Too concerned with others' views, easily compromising yourself",
      天梁: "Taking on too much responsibility, carrying others' burdens",
      廉贞: "Being stubborn, emotional instability"
    },
    财帛: {
      紫微: "Overreliance on authority, or excessive investment in appearances",
      天府: "Being too conservative, missing opportunities",
      天相: "Too afraid to ask for value, too relationship-focused, consumed by relationships",
      武曲: "Undervaluing yourself, exchanging physical labor for money, obsessing over details while missing the big picture",
      天机: "Overthinking causing missed entry opportunities, changing plans affecting financial stability",
      文曲: "Emotions affecting income rhythm, project-based work leading to large financial fluctuations",
      文昌: "Being too rational and suppressing spending, spending too much time optimizing systems rather than generating income",
      贪狼: "Wanting to spend too much, earning quickly but spending just as fast, lacking spending discipline",
      太阳: "Excessive giving, underpricing your value, afraid to charge fairly due to concerns about others' burden",
      太阴: "Easily influenced by emotions, afraid to ask for your worth, often helping those you shouldn't",
      巨门: "Talking more than doing, losing clients through inappropriate communication",
      天同: "Afraid to quote prices, giving too much value for free, relying on relationships to sustain service",
      七杀: "Rushing, lacking self-control, emotional trading",
      破军: "Repeatedly changing direction, lacking closure systems, thinking too big but acting too slowly",
      左辅: "Excessive giving without equivalent return",
      右弼: "Too many relationship debts leading to resource loss",
      天梁: "Overly idealistic, lacking money consciousness",
      廉贞: "Short-sighted, overly ambitious"
    },
    官禄: {
      紫微: "Excessive pursuit of power, neglecting team collaboration",
      天府: "Being too conservative, lacking innovation",
      天相: "Avoiding conflict leading to excessive compromise, unable to refuse and being exploited",
      武曲: "Overshadowing superiors, unable to delegate to the team, losing flexibility by trying too hard",
      天机: "Disliking management, lacking expression, easily overlooked",
      文曲: "Emotional management affecting project delivery, perfectionism, difficulty syncing with team systems",
      文昌: "Too focused on minor details, procrastination, never satisfied with completion level",
      贪狼: "Working based on mood, difficulty maintaining long-term focus, relationship issues ruining collaboration",
      太阳: "Afraid to ask for help, too independent to delegate, sticking to old methods without updating",
      太阴: "Lack of exposure, unwilling to promote yourself, easily underestimated",
      巨门: "Expressing too quickly for the team to follow, work style difficult to understand",
      天同: "Becoming marginalized due to passivity, missing opportunities due to conflict avoidance",
      七杀: "Difficulty integrating into team culture, overemphasis on freedom, unable to manage people",
      破军: "Lacking stable systems, easily misunderstood as unreliable, team has difficulty matching your pace",
      左辅: "Lacking personal voice, easily overlooked",
      右弼: "Easily swayed by emotions, affecting judgment",
      天梁: "Excessive tolerance, allowing problems to grow",
      廉贞: "Being too aggressive, easily making enemies"
    }
  }
};

export default watchout; 